import { render } from "./DiscountCodes.vue?vue&type=template&id=b1c25d26&scoped=true"
import script from "./DiscountCodes.js?vue&type=script&lang=js"
export * from "./DiscountCodes.js?vue&type=script&lang=js"

import "./style.css?vue&type=style&index=0&id=b1c25d26&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1c25d26"]])

export default __exports__